var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65078 18.6998C4.26745 18.6998 3.94661 18.5706 3.68828 18.3123C3.42995 18.054 3.30078 17.7331 3.30078 17.3498V6.7998C3.30078 6.41647 3.45495 6.07064 3.76328 5.7623C4.07161 5.45397 4.41745 5.2998 4.80078 5.2998H9.47578L11.4758 7.2998H19.2008C19.4841 7.2998 19.7341 7.3623 19.9508 7.4873C20.1674 7.6123 20.3424 7.78314 20.4758 7.9998H11.2008L9.20078 5.9998H4.80078C4.56745 5.9998 4.37578 6.0748 4.22578 6.2248C4.07578 6.3748 4.00078 6.56647 4.00078 6.7998V17.1998C4.00078 17.3831 4.04661 17.5331 4.13828 17.6498C4.22995 17.7665 4.35078 17.8665 4.50078 17.9498L6.72578 10.4998H22.6758L20.5008 17.7498C20.4174 18.0331 20.2549 18.2623 20.0133 18.4373C19.7716 18.6123 19.5008 18.6998 19.2008 18.6998H4.65078ZM5.22578 17.9998H19.7008L21.7258 11.1998H7.25078L5.22578 17.9998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.da1a23dfb5ab4bc9ce19bfa312e0a8ad.svg";
export { ForwardRef as ReactComponent };